import ReferrersSelect from "@Broker/@Modules/clients/referrers/components/referrers-select.vue";
import { onMounted, ref, toRefs, watch } from "@vue/composition-api";
import { useApplicationStoreActions, useApplicationStoreGetters } from "../../../../store/application-helpers";
import * as ApplicationGetters from "../../../../store/application-getters";
import * as ApplicationStoreActions from "../../../../store/lender-submit-actions";
import { useWidgetEvents } from "@Shared/@Composables/application/useWidgetEvents";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ParticipantReferrer",
  components: {
    ReferrersSelect
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const {
      sendWidgetMessage,
      setCloseWidgetOnExit
    } = useWidgetEvents(context);
    const {
      applicationId,
      clientUsername
    } = toRefs(props);
    const loading = ref(false);
    const selectedReferrerId = ref(null);
    const selectedReferer = ref(null);
    const {
      GET_APPLICATION_REFERRAL_SOURCE
    } = useApplicationStoreGetters([ApplicationGetters.GET_APPLICATION_REFERRAL_SOURCE]);
    const {
      ASSIGN_APPLICATION_REFERRAL_SOURCE
    } = useApplicationStoreActions([ApplicationStoreActions.ASSIGN_APPLICATION_REFERRAL_SOURCE]);
    const handleChange = (referrer, type) => {
      switch (type) {
        case "unselect":
          clearSelectedReferrerId();
          break;
        case "select":
          selectedReferrerId.value = referrer.id;
          selectedReferer.value = referrer;
          break;
      }
    };
    const setExistingReferrer = referrer => {
      selectedReferer.value = referrer;
    };
    const clearSelectedReferrerId = () => {
      selectedReferrerId.value = null;
    };
    watch(selectedReferrerId, async value => {
      loading.value = true;
      await ASSIGN_APPLICATION_REFERRAL_SOURCE({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        referrerId: value
      });
      sendWidgetMessage("validation-rules", "refresh");
      loading.value = false;
    });
    onMounted(async () => {
      setCloseWidgetOnExit(false);
      selectedReferrerId.value = GET_APPLICATION_REFERRAL_SOURCE.value;
    });
    return {
      selectedReferrerId,
      handleChange,
      setExistingReferrer,
      clearSelectedReferrerId,
      loading,
      selectedReferer
    };
  }
});